// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"9b0ca644","108":"3207252b","310":"4251048e","344":"6aaf7bdf","659":"9a08dd71","843":"caf5b5f7","925":"82b549fa"}[chunkId] + ".chunk.css";
};